const Lock = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none">
      <path
        fill="#927F71"
        d="M5.01 18.367c-.46 0-.853-.163-1.18-.49a1.611 1.611 0 0 1-.49-1.18V8.35c0-.46.163-.852.49-1.179a1.61 1.61 0 0 1 1.18-.49h.834V5.01c0-1.156.407-2.14 1.221-2.954.815-.813 1.799-1.22 2.953-1.221 1.155 0 2.14.407 2.954 1.221.815.815 1.222 1.8 1.22 2.953v1.67h.836c.459 0 .852.164 1.18.491.327.327.49.72.49 1.179v8.349c0 .459-.164.852-.49 1.18-.327.327-.72.49-1.18.49H5.009zm0-1.67h10.018V8.35H5.009v8.349zm5.008-2.504c.46 0 .853-.163 1.18-.49.327-.327.49-.72.49-1.18 0-.46-.164-.852-.49-1.179a1.613 1.613 0 0 0-1.18-.49 1.594 1.594 0 0 0-1.178.49c-.326.329-.49.722-.491 1.18-.002.457.162.85.49 1.179a1.6 1.6 0 0 0 1.18.49zM7.514 6.679h5.009V5.01c0-.695-.243-1.287-.73-1.774a2.415 2.415 0 0 0-1.775-.73c-.695 0-1.287.243-1.774.73a2.415 2.415 0 0 0-.73 1.774v1.67z"
      />
    </svg>
  );
};

export default Lock;
